import {
  SET_TIMER,
  SET_SHOW_TIMER,
  SET_PAUSE_TIMER,
  SET_START_TIMER,
  SET_ACTIVE_TIMER,
  SET_SHOW_TIMER_MODAL,
  SET_SHOW_TIMER_MODAL_FINANCE
} from '@/constants/mutationTypes'

const state = {
  time: {
    year: new Date().getFullYear(),
    month: new Date().getMonth(),
    date: new Date().getDate(),
    hours: '00',
    minutes: '00',
    seconds: '00',
    fullDate: new Date()
  },
  isShowTimerPanel: false,
  isShowTimerModal: false,
  isShowTimerModalFinance: false,
  isStart: true,
  isPause: true,
  activeTimer: {
    subTimers: {
    }
  }
}
const getters = {
  time: state => state.time,
  isStart: state => state.isStart,
  isPause: state => state.isPause,
  isShowTimerPanel: state => state.isShowTimerPanel,
  isShowTimerModal: state => state.isShowTimerModal,
  isShowTimerModalFinance: state => state.isShowTimerModalFinance,
  activeTimer: state => state.activeTimer
}
const actions = {
  setTimer ({commit}, data) {
    commit(SET_TIMER, {data})
  },
  setShowTimer ({commit}, data) {
    commit(SET_SHOW_TIMER, {data})
  },
  setShowTimerModal ({commit}, data) {
    commit(SET_SHOW_TIMER_MODAL, {data})
  },
  setShowTimerModalFinance ({commit}, data) {
    commit(SET_SHOW_TIMER_MODAL_FINANCE, {data})
  },
  setStart ({commit}, data) {
    commit(SET_START_TIMER, {data})
  },
  setPause ({commit}, data) {
    commit(SET_PAUSE_TIMER, {data})
  },
  setActiveTimer ({commit}, data) {
    commit(SET_ACTIVE_TIMER, {data})
  }
}
const mutations = {
  [SET_TIMER] (state, {data}) {
    state.time = data
  },
  [SET_SHOW_TIMER] (state, {data}) {
    state.isShowTimerPanel = data
  },
  [SET_SHOW_TIMER_MODAL] (state, {data}) {
    state.isShowTimerModal = data
  },
  [SET_SHOW_TIMER_MODAL_FINANCE] (state, {data}) {
    state.isShowTimerModalFinance = data
  },
  [SET_START_TIMER] (state, {data}) {
    state.isStart = data
  },
  [SET_PAUSE_TIMER] (state, {data}) {
    state.isPause = data
  },
  [SET_ACTIVE_TIMER] (state, {data}) {
    state.activeTimer = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/Timer/modules/store.js